<template>
  <div>
    <!-- <el-row :gutter="20">
      <el-col :span="6">
        <el-button-group>
          <el-button type="primary" icon="el-icon-plus" @click="add"></el-button>
          <el-button type="primary" icon="el-icon-delete" @click="deleteData"></el-button>
        </el-button-group>
      </el-col>
      <el-col :span="6">
        <el-input placeholder="请输入关键字" v-model="value">
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
      </el-col>
    </el-row> -->
    <el-form inline>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" icon="el-icon-plus" @click="add"></el-button>
          <el-button type="primary" icon="el-icon-delete" @click="deleteData"></el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="请输入关键字" v-model="value" style="margin-left:150px;">
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <edit ref='edit' :data='data' @save="save"></edit>
  </div>
</template>

<script>
  import Edit from "@/components/WhiteList/Edit";
  export default {
    components: {
      Edit
    },
    props: ["deletelist"],
    methods: {
      deleteData() {
        if (this.deletelist && this.deletelist.length > 0) {
          this.$getJSON("/radio/d_whitelst", {
            id_list: JSON.stringify(this.deletelist)
          }).then(res => {
            this.search();
            this.$message({
              type: "success",
              message: "删除成功"
            });
          });
        }
      },
      search() {
        this.$emit("search", this.value);
      },
      add() {
        this.$refs["edit"].show();
      },
      save(data, id) {
        data.id = id;
        this.$emit("add", data);
      }
    },
    data() {
      return {
        value: "",
        data: {}
      };
    }
  };

</script>

<style scoped>
  .el-row {
    margin-bottom: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/WhiteList/ToolBar.vue